import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-accessibility',
  templateUrl: './accessibility.component.html',
  styleUrls: ['./accessibility.component.scss', '../platform.component.scss']
})
export class AccessibilityComponent implements OnInit {


  tableData = [
    { subdivision: '1.1.1', criteria: '非テキストコンテンツ', level: 'A', application: '適用', result: '適合', remarks: 'PDFなどの文書ファイルは除く' },
    { subdivision: '1.2.1', criteria: '音声だけ及び映像だけ（収録済み）の達成基準', level: 'A', application: '適用なし', result: '適合', remarks: 'MP4などの映像ファイルは除く' },
    { subdivision: '1.2.2', criteria: 'キャプション（収録済み）の達成基準', level: 'A', application: '適用なし', result: '適合', remarks: 'MP4などの映像ファイルは除く' },
    { subdivision: '1.2.3', criteria: '音声解説又はメディアに対する代替コンテンツ（収録済み）の達成基準', level: 'A', application: '適用なし', result: '適合', remarks: 'MP4などの映像ファイルは除く' },
    { subdivision: '1.2.4', criteria: 'キャプション（ライブ）の達成基準', level: 'AA', application: '適用なし', result: '適合', remarks: 'MP4などの映像ファイルは除く' },
    { subdivision: '1.2.5', criteria: '音声解説（収録済み）の達成基準', level: 'AA', application: '適用なし', result: '適合', remarks: 'MP4などの映像ファイルは除く' },
    { subdivision: '1.3.1', criteria: '情報及び関係性の達成基準', level: 'A', application: '適用', result: '適合', remarks: 'PDFなどの文書ファイルは除く' },
    { subdivision: '1.3.2', criteria: '意味のある順序の達成基準', level: 'A', application: '適用', result: '適合', remarks: 'PDFなどの文書ファイルは除く' },
    { subdivision: '1.3.3', criteria: '感覚的な特徴の達成基準', level: 'A', application: '適用', result: '適合', remarks: '' },
    { subdivision: '1.4.1', criteria: '色の使用の達成基準', level: 'A', application: '適用', result: '適合', remarks: '' },
    { subdivision: '1.4.2', criteria: '音声の制御の達成基準', level: 'A', application: '適用なし', result: '適合', remarks: 'MP4などの映像ファイルは除く' },
    { subdivision: '1.4.3', criteria: 'コントラスト（最低限レベル）の達成基準', level: 'AA', application: '適用', result: '適合', remarks: 'PDFなどの文書ファイルは除く\nMP4などの映像ファイルは除く' },
    { subdivision: '1.4.4', criteria: 'テキストのサイズ変更の達成基準', level: 'AA', application: '適用', result: '適合', remarks: '' },
    { subdivision: '1.4.5', criteria: '文字画像の達成基準', level: 'AA', application: '適用', result: '適合', remarks: '' },
    { subdivision: '2.1.1', criteria: 'キーボードの達成基準', level: 'A', application: '適用', result: '適合', remarks: '' },
    { subdivision: '2.1.2', criteria: 'キーボードトラップなしの達成基準', level: 'A', application: '適用', result: '適合', remarks: '' },
    { subdivision: '2.2.1', criteria: 'タイミング調整可能の達成基準', level: 'A', application: '適用', result: '適合', remarks: '' },
    { subdivision: '2.2.2', criteria: '一時停止、停止及び非表示の達成基準', level: 'A', application: '適用', result: '適合', remarks: '' },
    { subdivision: '2.3.1', criteria: '3回のせん（閃）光、又はしきい（閾）値以下の達成基準', level: 'A', application: '適用', result: '適合', remarks: '' },
    { subdivision: '2.4.1', criteria: 'ブロックスキップの達成基準', level: 'A', application: '適用', result: '適合', remarks: '' },
    { subdivision: '2.4.2', criteria: 'ページタイトルの達成基準', level: 'A', application: '適用', result: '適合', remarks: '' },
    { subdivision: '2.4.3', criteria: 'フォーカス順序の達成基準', level: 'A', application: '適用', result: '適合', remarks: '' },
    { subdivision: '2.4.4', criteria: 'リンクの目的（コンテキスト内）の達成基準', level: 'A', application: '適用', result: '適合', remarks: '' },
    { subdivision: '2.4.5', criteria: '複数の手段の達成基準', level: 'AA', application: '適用', result: '適合', remarks: '' },
    { subdivision: '2.4.6', criteria: '見出し及びラベルの達成基準', level: 'AA', application: '適用', result: '適合', remarks: '' },
    { subdivision: '2.4.7', criteria: 'フォーカスの可視化の達成基準', level: 'AA', application: '適用', result: '適合', remarks: '' },
    { subdivision: '3.1.1', criteria: 'ページの言語の達成基準', level: 'A', application: '適用', result: '適合', remarks: '' },
    { subdivision: '3.1.2', criteria: '一部分の言語の達成基準', level: 'AA', application: '適用', result: '適合', remarks: '' },
    { subdivision: '3.2.1', criteria: 'フォーカス時の達成基準', level: 'A', application: '適用', result: '適合', remarks: '' },
    { subdivision: '3.2.2', criteria: '入力時の達成基準', level: 'A', application: '適用', result: '適合', remarks: '' },
    { subdivision: '3.2.3', criteria: '一貫したナビゲーションの達成基準', level: 'AA', application: '適用', result: '適合', remarks: '' },
    { subdivision: '3.2.4', criteria: '一貫した識別性の達成基準', level: 'AA', application: '適用', result: '適合', remarks: '' },
    { subdivision: '3.3.1', criteria: 'エラーの特定の達成基準', level: 'A', application: '適用', result: '適合', remarks: '' },
    { subdivision: '3.3.2', criteria: 'ラベル又は説明の達成基準', level: 'A', application: '適用', result: '適合', remarks: '' },
    { subdivision: '3.3.3', criteria: 'エラー修正の提案の達成基準', level: 'AA', application: '適用', result: '適合', remarks: '' },
    { subdivision: '3.3.4', criteria: 'エラー回避（法的、金融及びデータ）の達成基準', level: 'AA', application: '適用', result: '適合', remarks: '' },
    { subdivision: '4.1.1', criteria: '構文解析の達成基準', level: 'A', application: '適用', result: '適合', remarks: '' },
    { subdivision: '4.1.2', criteria: '名前（name）、役割（role）及び値（value）の達成基準', level: 'A', application: '適用', result: '適合', remarks: '' }
  ];

  mode: number = 0;
  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
  }
  toggleContact() {
  }
  moveContact() {
    this.router.navigate(["pages/platform/contact"]);
  }
  getManualSchool() {
    window.open("")
  }
  getManualSupport() {
    window.open("")
  }
}
